// src/components/Header.js
import React, { useContext } from 'react';
import { CartContext } from '../context/CartContext';

const Header = ({ restaurantInfo, onCartClick, onPayClick }) => {
  // Get global state and functions from the context
  const { cart, isDarkMode, toggleTheme } = useContext(CartContext);

  // Calculate cart count from the context's cart state
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  const name = restaurantInfo ? restaurantInfo.restaurant_name : "Digital Menu";
  const logoUrl = restaurantInfo ? restaurantInfo.logo_url : "";
  const socialLinks = {
    facebook: restaurantInfo ? restaurantInfo.social_facebook : "#",
    instagram: restaurantInfo ? restaurantInfo.social_instagram : "#",
    whatsapp: restaurantInfo ? restaurantInfo.social_whatsapp : "#",
    youtube: restaurantInfo ? restaurantInfo.social_youtube : "#",
    review: restaurantInfo ? restaurantInfo.review_link : "#",
  };

  return (
    <header className="app-header">
      <div className="logo-area">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="#" target="_blank" rel="noopener noreferrer">
          {logoUrl && <img src={logoUrl} alt="Restaurant Logo" id="restaurant-logo" />}
          <div>
            <h1 className="title">{name}</h1>
            <p className="subtitle">Digital Menu Card</p>
          </div>
        </a>
      </div>
      <div className="header-actions">
        <div className="social-icons">
          {socialLinks.facebook && <a href={socialLinks.facebook} className="fb" title="Facebook" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>}
          {socialLinks.instagram && <a href={socialLinks.instagram} className="ig" title="Instagram" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>}
          {socialLinks.whatsapp && <a href={socialLinks.whatsapp} className="wa" title="WhatsApp" target="_blank" rel="noopener noreferrer"><i className="fab fa-whatsapp"></i></a>}
          {socialLinks.youtube && <a href={socialLinks.youtube} className="yt" title="YouTube" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>}
        </div>
        {socialLinks.review && <a href={socialLinks.review} className="review-btn action-btn button-like" target="_blank" rel="noopener noreferrer">
          <i className="fas fa-star"></i> Review
        </a>}
        
        <button id="header-pay-btn" className="action-btn" title="Scan to Pay" onClick={onPayClick}>
          <i className="fas fa-qrcode"></i>
        </button>

        <button id="theme-toggle-btn" className="action-btn" title="Toggle Theme" onClick={toggleTheme}>
          {isDarkMode ? <i className="fas fa-sun"></i> : <i className="fas fa-moon"></i>}
        </button>

        <button className="cart-btn action-btn" id="open-cart-btn" title="View Cart" onClick={onCartClick}>
          <i className="fas fa-shopping-cart"></i>
          {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
        </button>
      </div>
    </header>
  );
};

export default Header;